<template>
  <b-modal v-model="isShow" :title="modalTitle" size="lg" centered scrollable no-close-on-backdrop @hide="onReset"
    id="actDataModal">
    <div id="agentRoleModal" class="body-content">
      <!-- 商户 -->
      <b-row class="line">
        <b-col>
          <label>{{ $t("common.clientName") }}</label>
          <v-select v-model.trim="$v.form.brokerId.$model" :disabled="modalType === 'Edit'" :options="brokerList">
            <div slot="no-options">{{ $t("common.noFind") }}</div>
          </v-select>
        </b-col>
      </b-row>

      <!--最高返佣等级 -->
      <b-row class="line">
        <b-col>
          <label><i class="text-danger">*</i>
            <!-- 最高返佣等级 -->
            {{ $t("lanV4.RebateratioLever") }}
          </label>
          <b-input-group>
            <b-form-input class="append-input" v-model.trim="$v.form.maxReturnLevel.$model" placeholder=""
              :state="chkState('maxReturnLevel')">
            </b-form-input>
          </b-input-group>
          <p class="text-danger" v-if="!$v.form.maxReturnLevel.required">
            <!-- 请输入最高返佣等级-->
            {{ $t("returnLevel.t8") }}
          </p>
          <p class="text-danger" v-if="!$v.form.maxReturnLevel.proofValue">
            <!-- 请输入最高返佣等级-->
            {{ $t("returnLevel.t8") }}
          </p>
        </b-col>
      </b-row>

      <!--状态-开关 -->
      <b-row class="line">
        <b-col>
          <label><i class="text-danger">*</i>
            <!-- 状态 -->
            {{ $t("returnLevel.t3") }}
          </label>
          <el-switch class="el-switch" v-model="form.statusSwitch" active-color="#095BE8" inactive-color="#E0E1E6" active-value="1"
            inactive-value="0">
          </el-switch>
        </b-col>
      </b-row>
    </div>
    <template v-slot:modal-footer>
      <b-button class="coustom-btn" variant="secondary" @click="onReset">{{
        $t("common.cancel")
      }}</b-button>
      <b-button class="coustom-btn" variant="primary" @click="save">{{
        $t("common.save")
      }}</b-button>
    </template>
  </b-modal>
</template>

<script>
import { requiredIf } from "vuelidate/lib/validators";
import { newFixInput, multiply, divide } from "@/apis/newmethods";
export default {
  name: "actDataModal",
  props: ["modalShow", "modalType", "itemData", "brokerId"],
  data() {
    return {
      isShow: false,
      modalTitle: null,
      form: {
        brokerId: null, //商户id
        maxReturnLevel: null, //最高返佣等级
        statusSwitch:'1',//状态
      },
      addSave: false,
      saveFlag: true, //保存防二次点击
      tipWidth: "200px",
      actType: null, //大赛类型：0：交易额&收益率大赛 1：交易额大赛  2：收益率大赛
      actStatus: null, //大赛状态：0 未开始 1 进行中 2 已结束
      brokerList: [],
      kvMaxLevel: 10,
    };
  },
  watch: {

    "form.brokerId"(v) {
      if (v) {
        this.getIndex();
      }
    },
    //最高返佣等级
    "form.maxReturnLevel"(v) {
      if (v) {
        this.$nextTick(() => {
          this.form.maxReturnLevel = newFixInput(v, 0, {
            minus: true,
            num: true,
            ints: 10,
            zero: true,
          });
        });
      }
    },
    modalShow(v) {
      this.isShow = v;
    },
  },
  computed: {
    isValid() {
      return !this.$v.form.$anyError;
    },
    url() {
      return this.$store.state.url.agent;
    },
    fixedMaxLevel() {
      return this.form.maxReturnLevel;
    }
  },
  created() {
    this.getBrokerList();
    if (this.modalType && this.modalType === "Add") {
      this.modalTitle = this.$t("returnLevel.t11");
    } else if (this.modalType && this.modalType === "Edit") {
      this.modalTitle = this.$t("returnLevel.t12");
    }
    this.isShow = this.modalShow;
  },
  validations: {
    form: {
      brokerId: {
        required: requiredIf(function () {
          return this.addSave;
        }),
      },
      maxReturnLevel: {
        required: requiredIf(function () {
          return this.addSave;
        }),
        proofValue: function (v) {
          if (v) {
            return Number(v) >= 1 && Number(v) <= 9999999999
          }
          return true;
        },
      },
    },
  },
  methods: {
    // 获取数据列表
    getIndex() {
      const paramsData = {
        companyId: this.form.brokerId ? this.form.brokerId.value : this.brokerId,
      };
      this.$http({
        url: this.$store.state.url.agent.index,
        params: paramsData,
      }).then(({ data, code, msg }) => {
        if (data && code.toString() === "0") {
          this.kvMaxLevel = data.configMaxLevel ? data.configMaxLevel : 10
        }
      });
    },
    // 获取商户列表
    getBrokerList() {
      this.$http({
        url: this.$store.state.url.common.getBrokerList,
      }).then(({ data, code, msg }) => {
        if (data && code.toString() === "0") {
          let arr = [];
          if (data.length) {
            data.map((item) => {
              arr.push({ label: item.brokerName, value: item.id });
            });
            this.brokerList = arr;
            this.form.brokerId = this.brokerId || arr[0]
            if (this.modalType && this.modalType === "Edit") {
              this.setEditData();
            }
          }
        } else {
          this.$bus.$emit("alert", { type: "error", message: msg });
        }
      });
    },
    // 乘法
    multiply(v1, v2) {
      return multiply(v1, v2);
    },
    // 除法
    divide(v1, v2) {
      return divide(v1, v2);
    },


    //编辑设置
    setEditData() {

      this.form.maxReturnLevel = this.itemData.maxLevel;
      this.brokerList.map((item) => {
        if (item.value == this.itemData.brokerId) {
          this.form.brokerId = item;
        }
      })
      this.form.statusSwitch = this.itemData.status.toString();
    },
    // 保存
    save() {
      this.addSave = true;
      let flag = true;
      if (!this.validate()) {
        flag = false;
      }
      if (!this.saveFlag || !flag) return;
      this.saveFlag = false;


      this.$http({
        url: 'rebate_level_update',
        params: {
          id: this.modalType == "Edit" ? this.itemData.id : undefined, // 编辑列表ID
          status: this.form.statusSwitch,
          maxRebateLevel: this.form.maxReturnLevel,
          brokerId: this.form.brokerId ? this.form.brokerId.value : this.brokerId,
          optType: this.modalType == "Edit"?'UPDATE':'INSERT',
        },
      }).then((data) => {
        this.saveFlag = true;
        if (data && data.code.toString() === "0") {
          this.$bus.$emit("alert", { type: "success", message: data.msg });
          this.$emit('getParentData');  // 刷新父组件数据
          this.onReset();
        } else {
          this.$bus.$emit("alert", { type: "error", message: data.msg });
        }
      });
    },
    onReset() {
      this.modalTitle = null;
      this.addSave = false;
      this.form.brokerId = null;
      this.$emit("changeModalShow", false);
      this.$emit("changeModalType", null);
      this.$v.form.$reset();
    },
    chkState(val) {
      const field = this.$v.form[val];
      if (field.$dirty) {
        if (field.$invalid) {
          return false;
        }
        return null;
      }
      return null;
    },
    validate() {
      this.$v.form.$touch();
      return this.isValid;
    },
  },
};
</script>

<style lang="scss">
#agentRoleModal {
  .icon-wh {
    width: 12px;
    height: 12px;
    position: relative;
    top: 1px;
  }

  .redio-text {
    margin-left: 8px;
    color: #263954;
    font-family: HarmonyOS-Regular;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    position: relative;
    top: 2px;
  }

  .redio-box {
    margin-left: 30px;
  }

  .radio-disabled {
    cursor: not-allowed;
  }

  .append {
    top: 10px;
  }

  .append-jh {
    width: 322px;
  }

  .form-control:disabled,
  .form-control[readonly] {
    color: #93979d !important;
    border: none !important;
  }

  .top-people {
    .col {
      flex-basis: auto;
    }

    .top-people-item {
      position: relative;
      display: flex;
      flex-direction: row;
      gap: 10px;

      .append-jh {
        flex: 1;
        width: auto;

        .text-danger {
          position: absolute;
          top: 40px;
        }
      }

      img {
        width: 15.5px;
        height: 15.5px;
        position: absolute;
        top: 49px;
        right: 5px;
      }
    }
  }

  .top-wh {
    margin-top: 23px;

    img {
      width: 16px;
      position: relative;
      top: -2px;
    }
  }

  .tip {
    color: #ffc64b;
    font-size: 12px;
    line-height: 17px;
    font-family: "HarmonyOS-Regular" !important;
    margin-top: 8px;
  }

  .coustom-icon {
    cursor: pointer;
    width: 40px;
    height: 40px;
    background: #f5f7fa;
    border-radius: 4px;
    text-align: center;
    line-height: 40px;
    flex-shrink: 0;
    //position: absolute;
    //right: 47px;
    //top: 28px;
  }

  .add-icon {
    width: 40px;
    height: 40px;
    background: #f5f7fa;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    //position: absolute;
    //right: 0px;
    //top: 28px;
  }
}
</style>
